<template>
    <div v-bind:id="item.scalePoolId" v-bind:class="[item.spike,iscollect?'testListItem_collect testListItem':'testListItem',isNoBorder?'testitem-noborder':'']">
        <!-- <div v-if="!showCategory" class="cpSummary">
            <span v-if="item.state*1==1" class="date">完成时间：{{ timeTransform(item.completeTime) }}</span>
            <span v-if="item.state*1==0" class="date">购买时间：{{ timeTransform(item.buyTime) }}</span>
        </div> -->
        <div class="cpInfo">
            <div class="cpInfo-text">

                <h1 class="title fs-16">{{switchTitle?myDesc:myTitle}}</h1>
                <p class="desc" v-if="showCategory">{{switchTitle?myTitle: myDesc}}</p>
                <div :class="{'pieces':showCategory,'pieces-mine':!showCategory}">
                    <span v-if="!TOUTIAOAPP && priceVisible" v-bind:class="['discount', 'fs-14', !!item.viewPromotionStyle? 'promotion': '']">&yen;{{item.discountPrice}}</span>
                    <!-- <span v-if="!TOUTIAOAPP" class="price">&yen;{{item.originalPrice}}</span> -->
                    <object v-if="showBtn">
                        <a v-if="item.state == undefined" href="javascript:;" v-on:tap="goBuy(item.pay_href)"
                           class="buyBtn">{{btnText}}</a>
                        <a v-if="item.state*1==1" class="buyBtn red">查看报告</a>
                        <a v-if="item.state*1==0" class="buyBtn green">去测试</a>
                    </object>
                    <span v-if="showBuyPeople && item.count" class="tested">{{cutNum(item.count, 4)}}人已测</span>
                </div>
                <div v-if="!showCategory" class="cpSummary">
                    <span v-if="item.state*1==1" class="date">完成时间：{{ timeTransform(item.completeTime) }}</span>
                    <span v-if="item.state*1==0" class="date">购买时间：{{ timeTransform(item.buyTime) }}</span>
                </div>
                <mineTestOrderNum v-if="!showCategory" :propOrderNum="item.orderNo" ></mineTestOrderNum>
            </div>
            <div class="cpInfo-img">
                <img v-lazy="item.introPicture" src="../../assets/testDefault.png" :key="item.img_url"/>
                <div v-if="!!item.viewPromotionStyle" class="promotion-brand"></div>
                <i
                    v-if="(!isOldVip || item.vipBuyType !== 2) && !isHideVipEntrance" 
                    class="vip-sign"
                    :class="{'is-half': item.vipBuyType === 1}"
                ></i>
            </div>
        </div>
    </div>
</template>

<script>
    import mineTestOrderNum from '../show/mine/mineTestOrderNum.vue';
    export default {
        name: 'indexListItem',
        props: {
            showBtn: {
                required: false,
                default: false,
                type: Boolean,
            },
            showBuyPeople: {
                required: false,
                default: true,
                type: Boolean,
            },
            item: {
                required: true,
                type: Object
            },
            btnText: {
                required: false,
                type: String,
                default: '立即购买'
            },
            showCategory: {
                required: false,
                type: Boolean,
                default: true,
            },
            switchTitle:{
                required: false,
                type: Boolean,
                default: false,
            },
            iscollect:{
                required: false,
                type: Boolean,
                default: false,            
            },
            isNoBorder:{
                required: false,
                type: Boolean,
                default: false,
            }
        },
        components:{
            mineTestOrderNum
        },
        computed: {
            myTitle() {
                // 不是我的测评调用
                if (this.item.state == undefined) {
                    return this.item.shortDescribe
                } else {
                    return this.item.name
                }
            },
            myDesc() {
                // 不是我的测评调用
                if (this.item.state == undefined) {
                    return this.item.name
                } else {
                    return this.item.shortDescribe
                }
            },

            priceVisible() {
                return !(this.isHpnk && +this.item.discountPrice === 0)
            }
        },
        methods: {
            cutNum(num, leval = 4){
                // 因为返回裁剪后的都是以万为单位，所以规定最少是10的4次幂;
                let standard = Math.pow(10, leval > 4 ? leval : 4);
                if (num > standard) {
                    // 虽然level不同，但是最后返回的都要多少多少W人为单位
                    return `${(num / 10000).toFixed(1)}W`
                } else {
                    return num;
                }
            },
            timeTransform(time) {
                const myTime = new Date(time);
                return `${myTime.getFullYear()}年${myTime.getMonth() + 1}月${myTime.getDate()}日${myTime.getHours()}:${myTime.getMinutes()}:${myTime.getSeconds()}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/function';

    .testListItem {
        background: #fff;
        /*margin-bottom: topx(6rem);*/
        padding: topx(20rem);
        background: #FFFFFF;
        // border: 1px solid #F0F0F0;
        box-shadow: 0 0 topx(10rem) 0 rgba(76,75,88,0.05);
        border-radius: topx(10rem);
        margin-bottom: topx(20rem);
        .cpSummary {
            display: block;
            margin: topx(30rem) 0 topx(52rem) 0;
            font-size: 0;
            overflow:hidden;
            .category {
                position: relative;
                font-size: 12px;
                color: #333;
                line-height: 1;
                padding-left: topx(30rem);
                &:before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 0;
                    display: block;
                    margin-top: topx(-10rem);
                    width: topx(16rem);
                    height: topx(16rem);
                    border: 1px solid #00D438;
                    border-radius: topx(16rem);
                }
            }
            .date {
                float: left;
                font-size: topx(24rem);
                color: #999999;
                line-height: 1;
            }
        }

        .cpInfo {
            position: relative;
            display: flex;
            &-text {
                flex: 1 1 0;
                position: relative;
                min-height: topx(160rem);
                padding-right: topx(20rem);
                .title {
                    margin-bottom: topx(5rem);
                    /* font-size: 16px; */
                    /* max-width: 12.5em; */
                    max-width: 92%;
                    max-height: topx(42rem * 2);
                    line-height: 1.31;
                    color: #333333;
                    text-align: left;
                    @include limitLine(2);
                }
                .desc {
                    font-size: 12px;
                    color: #999999;
                    line-height: 1.42;
                    @include limitLine(1);
                    margin-bottom: topx(30rem);
                }
                .pieces {
                    /*overflow: hidden;*/
                    position: absolute;
                    height: topx(30rem);
                    line-height: topx(30rem);
                    font-size: 0;
                    bottom: 0;
                    left: 0;
                    right: topx(20rem);
                    .discount {
                        margin-right: topx(10rem);
                        /* font-size: 14px; */
                        color: #FFA800;
                        font-weight: bold;
                    }
                    .promotion {
                        position: relative;
                        color: #FF5050;
                        //padding-left: topx(54rem);
                        /*&:before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 50%;
                            left: 0;
                            transform: translate(0, -50%);
                            width: topx(50rem);
                            height: topx(30rem);
                            background: url('../../assets/promotion/icon-item.png') no-repeat;
                            background-size: topx(50rem) topx(29rem);
                        }*/
                    }
                    .price {
                        font-size: 10px;
                        color: #999;
                        text-decoration: line-through;
                    }
                    .tested {
                        float: right;
                        font-size: 12px;
                        color: #999;
                    }
                }
                .pieces-mine{
                    /*overflow: hidden;*/
                    // position: absolute;
                    height: topx(30rem);
                    line-height: topx(30rem);
                    font-size: 0;
                    left: 0;
                    margin-top: topx(20rem);

                    .discount {
                        margin-right: topx(10rem);
                        /* font-size: 14px; */
                        color: #FFA800;
                        font-weight: bold;
                    }
                    .promotion {
                        position: relative;
                        color: #FF5050;
                        //padding-left: topx(54rem);
                        /*&:before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 50%;
                            left: 0;
                            transform: translate(0, -50%);
                            width: topx(50rem);
                            height: topx(30rem);
                            background: url('../../assets/promotion/icon-item.png') no-repeat;
                            background-size: topx(50rem) topx(29rem);
                        }*/
                    }
                    .price {
                        font-size: 10px;
                        color: #999;
                        text-decoration: line-through;
                    }
                    .tested {
                        float: right;
                        font-size: 12px;
                        color: #999;
                    }
                }
            }
            &-img {
                position: relative;
                width: topx(160rem);
                height: topx(160rem);
                background: #b2b2b2;
                border-radius: topx(6rem);
                img {
                    width: 100%;
                    height: 100%;
                    background: url('../../assets/testDefault.png');
                    background-size: cover;
                    border-radius: topx(6rem);
                }
                .promotion-brand {
                    position: absolute;
                    z-index: 2;
                    top: topx(10rem);
                    left: topx(10rem);
                    width: topx(40rem);
                    height: topx(40rem);
                    background: url('../../assets/promotion/icon-brand.svg') no-repeat;
                    background-size: cover;
                }
                .tag {
                    position: absolute;
                    box-sizing: border-box;
                    bottom: topx(10rem);
                    right: topx(-7rem);
                    padding: topx(6rem) topx(4rem);
                    line-height: 1;
                    color: #7FA7F8;
                    text-align: center;
                    font-size: 10px;
                    font-style: normal;
                    background: #FFFFFF;
                    border: topx(1rem) solid #7FA7F8;
                    border-radius: 2px;
                }
            }
        }
    }
    .testListItem_collect{
        border:none !important;
    }
    .testitem-noborder{
        border:none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/common/testItem.vue